export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  EMPLOYEE = 'EMPLOYEE',
}

export enum HSTFrequency {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  ANNUAL = 'ANNUAL',
}

export enum FilingStatus {
  PENDING = 'PENDING',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS',
  RECEIVED = 'RECEIVED',
  FILED = 'FILED',
  OVERDUE = 'OVERDUE',
  INACTIVE = 'INACTIVE',
}
export interface FrequencyChange {
  oldFrequency: HSTFrequency;
  newFrequency: HSTFrequency;
  changeDate: string;
  changedBy: string;
  changedAt: string;
}

export interface Client {
  id: string;
  clientName: string;
  clientEmail: string;
  hstFrequency: HSTFrequency;
  periodStartDate: string;
  periodEndDate: string;
  dueDate: string;
  employeeAssigned: string;
  employeeEmail: string;
  ccEmails: string[];
  status: FilingStatus;
  filingRecords?: FilingRecord[];
  createdAt: string;
  updatedAt: string;
  emailNotificationsMuted?: boolean;  
  newFrequency?: HSTFrequency | null;  
  frequencyChangeDate?: string | null;  
  frequencyHistory?: FrequencyChange[];
}

export interface Comment {
  id: string;
  clientId: string;
  userId: string;
  userName: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface FilingRecord {
  id: string;
  clientId: string;
  client?: Client;
  periodStartDate: string;
  periodEndDate: string;
  dueDate: string;
  status: FilingStatus;
  filedDate: string | null;
  notes: string | null;
  reminderOneWeekSent: boolean;
  reminderOneMonthSent: boolean;
  reminderTwoWeeksSent: boolean;
  reminderOneDayAfterPeriodEnd: boolean;
  reminderTwoWeeksAfterPeriodEnd: boolean;
  reminderOneMonthBeforeDue: boolean;
  sentToClient: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateClientDTO {
  clientName: string;
  clientEmail: string;
  hstFrequency: HSTFrequency;
  periodStartDate: string;
  periodEndDate: string;
  dueDate: string;
  employeeAssigned: string;
  employeeEmail: string;
  ccEmails?: string[];
}

export interface UpdateClientDTO extends Partial<CreateClientDTO> {
  status?: FilingStatus;
}

export interface UpdateFilingStatusDTO {
  status: FilingStatus;
  filedDate?: string;
  notes?: string;
}

export interface ApiResponse<T> {
  data: T;
  message?: string;
  success?: boolean;
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
}
